import React from "react";
import { BaseEdge, getSmoothStepPath, getStraightPath, Position } from "@xyflow/react";
import { getPipelineLayout } from "./layout";

const { fanoutRowY } = getPipelineLayout();
const FANOUT_BUS_Y = fanoutRowY - 24;

function MainPipelineEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  markerEnd,
  style,
}) {
  const [path] = getStraightPath({ sourceX, sourceY, targetX, targetY });
  return <BaseEdge id={id} path={path} markerEnd={markerEnd} style={style} />;
}

function FanoutPipelineEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition = Position.Right,
  targetPosition = Position.Left,
  markerEnd,
  style,
}) {
  const busX = sourceX + 28;
  const [path] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    centerX: busX,
    centerY: FANOUT_BUS_Y,
    borderRadius: 10,
    offset: 12,
  });
  return <BaseEdge id={id} path={path} markerEnd={markerEnd} style={style} />;
}

function LambdaFeedEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  markerEnd,
  style,
}) {
  const bendX = sourceX + Math.max(20, (targetX - sourceX) * 0.5);
  const bendY = (sourceY + targetY) / 2;
  const [path] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition: Position.Right,
    targetX,
    targetY,
    targetPosition: Position.Left,
    centerX: bendX,
    centerY: bendY,
    borderRadius: 10,
    offset: 12,
  });
  return <BaseEdge id={id} path={path} markerEnd={markerEnd} style={style} />;
}

export const edgeTypes = {
  mainEdge: MainPipelineEdge,
  fanoutEdge: FanoutPipelineEdge,
  lambdaFeedEdge: LambdaFeedEdge,
};
